import { getReservePrice } from "../properties/getReservePrices";
import { getSortOption } from "../properties/sortOptions";
import { getFilterOption } from "../properties/getFilterOptions";

export default async function urlToPayload(
  urlData: any,
  form: any,
  facets: any,
  router: any,
  city: any
) {
  const query = router?.query;
  const filterByObject: any = [
    {
      attribute: "status",
      op: "eq",
      value: "active",
    },
  ];
  const sortByObject: any = [];

  if (urlData?.asset_type) {
    const data: any = facets?.asset?.filter(
      (item: any) => item.slug === urlData.asset_type
    );
    filterByObject.push({
      attribute: "asset-type",
      value: [urlData.asset_type],
    });

    if (data && data.length > 0) {
      form.setField("asset_type", {
        label: data[0].name,
        value: data[0].slug,
      });
    } else {
    }
  }

  if (form.value.asset_type) {
    const data: any = facets?.asset?.filter(
      (item: any) => item.slug === form.value.asset_type.value
    );
    filterByObject.push({
      attribute: "asset-type",
      value: [form.value.asset_type.value],
    });

    if (data && data.length > 0) {
      form.setField("asset_type", {
        label: data[0].name,
        value: data[0].slug,
      });
    } else {
    }
  }

  if (urlData?.sub_asset_type) {
    // console.log("facets::>", facets?.sub_asset_type);
    if (facets) {
      const data: any = facets?.sub_asset_type?.filter(
        (item: any) => item.slug === urlData.sub_asset_type
      );
      // console.log("data:::>", data);
      filterByObject.push({
        attribute: "sub-asset-type",
        value: [urlData.sub_asset_type],
      });

      if (data && data.length > 0) {
        form.setField("sub_asset_type", {
          label: data[0].name,
          value: data[0].slug,
        });
      } else {
      }
    }
  }

  if (urlData?.state) {
    const data: any = facets?.state?.filter(
      (item: any) => item.slug === urlData.state
    );
    filterByObject.push({
      attribute: "state",
      value: [urlData.state],
    });
    if (data && data.length > 0) {
      form.setField("state", {
        label: data[0].name,
        value: data[0].slug,
      });
    } else {
    }
  }

  if (urlData?.city) {
    const data: any = facets?.city?.filter(
      (item: any) => item.slug === urlData.city
    );
    filterByObject.push({
      attribute: "city",
      value: [urlData.city],
    });
    if (data && data.length > 0) {
      form.setField("city", {
        label: data[0].name,
        value: data[0].slug,
      });
    } else {
    }
  }

  if (urlData?.locality) {
    filterByObject.push({
      attribute: "locality",
      value: [urlData.locality],
    });

    form.setField("locality", [
      {
        label: urlData.locality,
        value: urlData.locality,
      },
    ]);
  }

  if (
    ((urlData !== undefined && !urlData?.city) ||
      (!urlData?.city && !urlData?.state && urlData?.locality)) &&
    city?.value &&
    form.value.city === ""
  ) {
    filterByObject.push({
      attribute: "city",
      value: [city?.value],
    });
    form.setField("city", city);
  }
  if (urlData?.bank) {
    const data: any = facets?.bank?.filter(
      (item: any) => item.slug === urlData.bank
    );

    filterByObject.push({
      attribute: "bank",
      value: [urlData.bank],
    });
    if (data && data.length > 0) {
      form.setField("institutes", {
        label: data[0].name,
        value: data[0].slug,
      });
    } else {
    }
  }

  if (query?.reserve_price) {
    form.setField("reserve_price", query.reserve_price);
  }

  if (query?.sort_by) {
    const data: any = await getSortOption({
      slug: query.sort_by,
    });

    if (data && data.length > 0) {
      const element = data[0].value;
      if (element === "reserve_price_asc") {
        sortByObject.push({
          attribute: "reserve_price",
          order: "asc",
        });
      }

      if (element === "reserve_price_desc") {
        sortByObject.push({
          attribute: "reserve_price",
          order: "desc",
        });
      }

      if (element === "auction_date_asc") {
        sortByObject.push({
          attribute: "auction_start_date_time",
          order: "asc",
        });
      }

      form.setField("sort_by", { value: data[0].value, label: data[0].label });
    }
  }

  if (query?.filter_by) {
    if (query.filter_by === "auction_verified") {
      filterByObject.push({
        attribute: "ab_verified",
        op: "eq",
        value: true,
      });
      form.setField("ab_verified", {
        label: "Verified Property",
        value: "auction_verified",
      });
    }
    if (query.filter_by === "financing_avaibility") {
      filterByObject.push({
        attribute: "financing_facility",
        op: "eq",
        value: true,
      });
    }
    if (query.filter_by === "featured_properties") {
      filterByObject.push({
        attribute: "featured",
        op: "eq",
        value: true,
      });
    }

    const data: any = await getFilterOption({
      slug: [query.filter_by],
    });

    if (data && data.length > 0) {
      form.setField("filter_by", {
        value: data[0].value,
        label: data[0].label,
      });
    }
  }
  // else {
  //   console.log(
  //     "PROPERTIES FOR UPCOMING AUCTION----->>>>>",
  //     query.filter_by,
  //     form.value.filter_by
  //   );
  //   if (form?.value?.filter_by && form.getField("filter_by") === "") {
  //     console.log("cccc");
  //     form.setField("filter_by", {
  //       value: "dated",
  //       label: "Scheduled",
  //     });
  //   }
  // }

  let payload = {
    apiConfig: {
      includeRelations: ["city", "sub_asset_type", "bank"],
      includeMutations: ["state", "asset"],
      includeFacets: true,
    },
    limitBy: {
      per_page: 9,
      page: 1,
    },
    sortBy: sortByObject,
    filterBy: filterByObject,
  };
  return payload;
}
